import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import {
  getAllIdChecked,
  getAllParentChecked,
} from '../../../../../common/tree/helper'
import { CRITERIA_GROUP, MAX_INDUSTRY_LEVEL } from '../../../common/constant'
import {
  selectIndustryICB,
  selectIndustryICBById,
  selectIndustryVSIC,
  selectIndustryVSICById,
} from '../../../common/store/slice'
import { changeCriteria, selectCriteria } from '../../store/slice'
import { INDUSTRY_TYPE } from './../../../common/constant'
import classes from './index.module.scss'
import { IndustryItem } from './IndustryItem'

export const CriteriaIndustry = () => {
  const dispatch = useDispatch()

  const industryVSIC = useSelector(selectIndustryVSIC)
  const industryICB = useSelector(selectIndustryICB)
  const industryVSICById = useSelector(selectIndustryVSICById())
  const industryICBById = useSelector(selectIndustryICBById())
  const criteriaIndustryType = useSelector(
    selectCriteria([CRITERIA_GROUP.INDUSTRY, 'industryType']),
  )
  const listChecked = useSelector(
    selectCriteria([CRITERIA_GROUP.INDUSTRY, 'listIdCheckedTree']),
  )
  const listParentChecked = useSelector(
    selectCriteria([CRITERIA_GROUP.INDUSTRY, 'ids']),
  )

  const treeData =
    criteriaIndustryType === INDUSTRY_TYPE.ICB ? industryICB : industryVSIC

  useEffect(() => {
    dispatch(
      changeCriteria({
        path: [CRITERIA_GROUP.INDUSTRY, 'ids'],
        data: getAllParentChecked(treeData, 'id', listChecked),
      }),
    )
  }, [treeData, listChecked])

  const handleDeleteIndustry = () => {
    dispatch(
      changeCriteria({
        path: [CRITERIA_GROUP.INDUSTRY, 'listIdCheckedTree'],
        data: [],
      }),
    )
  }

  const handleDeleteItem = (id) => {
    const deleteIds = getAllIdChecked(treeData, 'id', [id])
    const newListChecked = listChecked.filter(
      (itemId) => !deleteIds.includes(itemId),
    )

    dispatch(
      changeCriteria({
        path: [CRITERIA_GROUP.INDUSTRY, 'listIdCheckedTree'],
        data: newListChecked,
      }),
    )
  }

  const renderContent = () => {
    const industryData =
      criteriaIndustryType === INDUSTRY_TYPE.ICB
        ? industryICBById
        : industryVSICById

    const data = listParentChecked.map((id) => industryData[id])
    return new Array(MAX_INDUSTRY_LEVEL).fill(undefined).map((val, index) => {
      const level = index + 1
      const industries = data.filter((item) => item.level === level)
      return industries.length ? (
        <IndustryItem
          key={level}
          level={level}
          industries={industries}
          handleDeleteItem={handleDeleteItem}
        />
      ) : null
    })
  }

  return (
    <Element style={{ color: '#3A414B' }}>
      <Element className={classes.header} style={{ borderColor: '#d5d5d5' }}>
        <Element className={classes.industryName}>
          {criteriaIndustryType}
        </Element>
        <Icon
          className="icon-trash-fill"
          style={{ color: '#9C9C9C', fontSize: 14 }}
          onClick={handleDeleteIndustry}
        />
      </Element>
      <Element className={classes.content}>{renderContent()}</Element>
    </Element>
  )
}
